import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Download } from '../interfaces/download.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  public constructor(private readonly api: ApiService) {}

  public get(organisationId: string, downloadId: string, admin?: boolean ): Observable<Download> {
    const path: string = admin ? `admin/organisations/${organisationId}/downloads/${encodeURIComponent(downloadId)}`
      :  `organisations/${organisationId}/downloads/${encodeURIComponent(downloadId)}`

    return this.api.get<Download>( path );
  }
}
